import { render, staticRenderFns } from "./SpecialTutor.vue?vue&type=template&id=2ac0320e&scoped=true"
import script from "./SpecialTutor.vue?vue&type=script&lang=js"
export * from "./SpecialTutor.vue?vue&type=script&lang=js"
import style0 from "./SpecialTutor.vue?vue&type=style&index=0&id=2ac0320e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac0320e",
  null
  
)

export default component.exports